import React from "react"
import { Button } from "@chakra-ui/react"

export default function DevButton() {
  return <Button>Test</Button>
}
